<template>
  <div class="usersExampleUser">
    <Row type="flex" justify="space-around">
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 2"
        >
          <use xlink:href="#icon-mpai-people_8"></use>
        </svg>

        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          25岁
        </div>
        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          小饰品电商老板
        </div>
      </i-col>
    </Row>

    <div v-if="index === 2" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col span="7"></i-col>
        <i-col class="pinched" span="10">
          <p>
            最近直播带货很火，我想借助一些平台来实现直播和短视频带货，但是需要分析精准客户，选择最优的广告投放方式。朋友告诉我学习数据分析可以辅助决策，找到网上的速成数据分析课程，都是挂羊头卖狗肉，不是要编程就是学习一大堆专业软件，没有一两年学习连工具都没法上手，更别说那些看着就头皮发麻的数学理论。太难了！无从下手。
          </p>
        </i-col>
        <i-col span="7"></i-col>
      </row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 2
    };
  }
};
</script>

<style lang="less" scoped>
.fontStyle {
  color: #2d8cf0;
}
.fontStyle_bold {
  font-weight: bold;
}
.usersExampleUser {
  padding: 10px 0;
  width: 100%;
  .users_plane {
    height: 130px;
    text-align: center;
    cursor: pointer;
    .users_plane_img {
      height: 80px;
      width: 100%;
    }
  }
}
.pinchedContent {
  display: flex;
  justify-content: center;
}
.pinchedContext {
  padding: 0 50px;
  max-width: 1500px;
}
.pinchedRight {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedRight:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 86.5%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedRight:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 86.5%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedRight > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 13.5%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinchedleft {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedleft:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 13.5%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedleft:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 13.5%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedleft > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 86.5%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinched {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinched:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinched:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinched > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
</style>
